import { ValueRegistryCategory } from '../../../registry/value/ValueRegistryCategory';
import { ValueRegistryDraftStage } from './ValueRegistryDraftStage';
export class ValueRegistryDraft extends ValueRegistryCategory {
    label = 'Draft';
    constructor(parent) {
        super(parent);
    }
    c_stage = new ValueRegistryDraftStage(this);
}
